<template>
    <div>
        <!-- <div v-if="Names == ''">
                <Mainlayout></Mainlayout>
            </div>
            <div v-else>
                <MainlayoutLogin></MainlayoutLogin>
            </div> -->
            <Mainlayout></Mainlayout>
        <CCol sm="12" style="background-size: cover;" :style="{ backgroundImage: `url(${backgroundUrl})` }">
            <CCol sm="12" lg="12">
                <CRow>
                    <CCol sm="12" lg="12">
                        <div style="margin-top: 10%">
                            <div class="text-center">
                                <h3 class="custom-32px-500 text-center font-color-171717"><span class="custom-32px-600">Accelerate your hiring process with our subscription packages designed to streamline your recruitment efforts.</span> </h3>
                                <p class="custom-16px-400">Enhance your hiring process with our subscription packages, offering industry-specific filters, AI-ranked candidate lists, <brdetailed reports on each candidates, customisable interview questions, and collaborative tools for team involvement.</p>
                            </div>
    
                        </div>
    
    
    
    
                    </CCol>
    
                </CRow>
            </CCol>
        </CCol>
            <CCol sm="12" style="background-size: cover; margin: auto;background-color: #fff;">
                <br /><br />
            <div class="text-center">
                <h3 class="custom-24px-500 text-center font-color-171717"><span class="custom-32px-600">Company</span> Subscription </h3>
                <p class="custom-16px-400">Our AI-powered platform offers top-notch feedback, along with exclusive insights from industry experts.</p>
            </div>
    
                <CRow>
                    <CCol sm="12" lg="12">
                        <div>
                            <CCol sm="12" style="width: 100%; background-size: cover; margin: auto;">
                                <CRow style="display: flex; flex-wrap: wrap;">
                                    <CCol sm="3" style="flex: 1 0 25%;" v-for="item in packages" v-bind:key="item.packageId">
                                        <CCard class="b-20 bg-FAFAFA" v-if="item.isPopular === false">
                                            <h3 class="custom-24px-500 text-center mt-3">
                                                {{ item.packageName }} Package
                                            </h3>
                                            <span class="text-center" v-if="item.packageName != 'Enterprise'"><label class="custom-48px-500">$ {{ item.packagePrice | formattedPrice }}</label><label v-for="items,index in item.PackageDetails" v-bind:key="items.packageDetailId"> <div v-if="index == 0">/ {{ items.Type }}</div></label></span>
                                            <p class="custom-16px-400 text-center" style="width:70%;margin:0 auto">{{ item.packageDescription }}</p>
                                            <hr class="custom-hr m-4" />
                                            <div class="p-2">
                                                    <CRow v-for="items in item.PackageDetails" v-bind:key="items.packageDetailId">
                                                        <CCol sm="1"><img src="../assets/img/check.png" style="max-width:20px"/> </CCol>
                                                        <CCol sm="10"><span v-html="formatDescription(items.Description)"></span></CCol>
                                                    </CRow>
                                            </div>
                    
                                            <div class="text-center m-0 mt-2 p-2">
                                                <CButton class="custom-border-purple p-2 text-white text-center" v-if="item.packageName === 'Enterprise'" @click="OpenForm()" block>Contact Us</CButton>
                                                <CButton class="custom-border-purple p-2 text-white text-center" v-else @click="GoToConfirmation(item.packagePrice, item.packageId)" block>Subscribe</CButton>
                                            </div>
                                        </CCard>

                                        <CCard class="b-20 bg-928AFD text-white" v-else>
                                            <img src="../assets/img/mostpopular.png" style="position: absolute;width: 130px;top: -30px;right: 10px;"/>
                                            <h3 class="custom-24px-500 text-center mt-3 text-white">
                                                {{ item.packageName }} Package
                                            </h3>
                                            <span class="text-center"  v-if="item.packageName != 'Enterprise'"><label class="custom-48px-500 text-white">$ {{ item.packagePrice | formattedPrice }}</label><label v-for="items,index in item.PackageDetails" v-bind:key="items.packageDetailId"> <div v-if="index == 0">/ {{ items.Type }}</div></label></span>
                                            <p class="custom-16px-400 text-center text-white" style="width:70%;margin:0 auto">{{ item.packageDescription }}</p>
                                            <hr class="custom-hr-white m-4" />
                                            <div class="p-2">
                                                    <CRow v-for="items in item.PackageDetails" v-bind:key="items.packageDetailId">
                                                        <CCol sm="1"><img src="../assets/img/check-white.png" style="max-width:20px"/> </CCol>
                                                        <CCol sm="10"><span v-html="formatDescription(items.Description)"></span></CCol>
                                                    </CRow>
                                            </div>
                    
                                            <div class="text-center m-0 mt-2 p-2">
                                                <CButton class="bg-white p-2 text-center font-color-928AFD b-20" v-if="item.packageName === 'Enterprise'" @click="OpenForm()" block>Contact Us</CButton>
                                                <CButton class="bg-white p-2 text-center font-color-928AFD b-20" v-else @click="GoToConfirmation(item.packagePrice, item.packageId)" block>Subscribe</CButton>
                                            </div>
                                        </CCard>
                                    </CCol>
    
    
    
                                </CRow>
    
    
                            </CCol>
                        </div>
    
    
    
                    </CCol>
    
                </CRow>
            </CCol>




            <CCol sm="12" style="background-size: cover; margin: auto;background-color: #fff;">
            <br /><br />
            <div class="text-center">
                <h3 class="custom-32px-500 text-center font-color-171717"><span class="custom-32px-600">Why you must subscribe?</span> </h3>
                <p class="custom-16px-400">Get to know the talented individuals driving our company forward.</p>
            </div>
    
            <CCol sm="12" style="width: 80%; background-size: cover; margin: auto;">
                <CRow>
                    <CCol sm="6">
                        <CCard class="bg-white b-20 p-20" style="border:none">
                            <img src="../assets/img/Illustration3.png" style="max-width:100%" class="m-4 b-20" />
    
                        </CCard>
                    </CCol>
                    <CCol sm="6">
                        <br />
                        <h3 class="custom-32px-600 text-left mt-5 ml-1" data-aos="zoom-in">
                            With Subscribe Plan
                        </h3>
                        <p class="custom-16px-400 text-left" data-aos="zoom-out">
                            <CRow>
                                <CCol sm="1">
                                    <img src="../assets/img/tick-circle-purple.png" width="20px" />
                                </CCol>
                                <CCol sm="11" class="custom-18px-400">
                                    <strong>Expand Your Options:  </strong>Select a larger pool of candidates to broaden your options.
                                </CCol>
    
                                <CCol sm="1">
                                    <img src="../assets/img/tick-circle-purple.png" width="20px" />
                                </CCol>
                                <CCol sm="11" class="custom-18px-400">
                                    <strong>Access comprehensive details: </strong> Gain access to view interview videos, check detailed scores, and download the results.
                                </CCol>
    
                                <CCol sm="1">
                                    <img src="../assets/img/tick-circle-purple.png" width="20px" />
                                </CCol>
                                <CCol sm="11" class="custom-18px-400">
                                    <strong> Personalized Ratings: </strong> Provide ratings for candidates to ensure you find the perfect match for your needs.
                                </CCol>
    
                                <CCol sm="1">
                                    <img src="../assets/img/tick-circle-purple.png" width="20px" />
                                </CCol>
                                <CCol sm="11" class="custom-18px-400">
                                    <strong>Rapid screening and assessment: </strong>Enjoy additional features such as industry-based filters, AI-powered rankings and expert evaluations.
                                </CCol>
                            </CRow>
                        </p>
    
                    </CCol>
                    <CCol sm="6">
                        <br />
                        <h3 class="custom-32px-600 text-left mt-5 ml-1" data-aos="zoom-in">
                            Without Subscribe Plan
                        </h3>
                        <p class="custom-16px-400 text-left" data-aos="zoom-out">
                            <CRow>
                                <CCol sm="1">
                                    <img src="../assets/img/tick-circle-purple.png" width="20px" />
                                </CCol>
                                <CCol sm="11" class="custom-18px-400">
                                    <strong>Limited AI Feedback:  </strong>Basic analysis on a limited number of interviews without the in-depth insights.
                                </CCol>
    
                                <CCol sm="1">
                                    <img src="../assets/img/tick-circle-purple.png" width="20px" />
                                </CCol>
                                <CCol sm="11" class="custom-18px-400">
                                    <strong>Standard Support: </strong> Regular support with longer response times.
                                </CCol>
    
                                <CCol sm="1">
                                    <img src="../assets/img/tick-circle-purple.png" width="20px" />
                                </CCol>
                                <CCol sm="11" class="custom-18px-400">
                                    <strong> Basic Resources: </strong> Access only to free resources with limited functionality.
                                </CCol>
    
                                <CCol sm="1">
                                    <img src="../assets/img/tick-circle-purple.png" width="20px" />
                                </CCol>
                                <CCol sm="11" class="custom-18px-400">
                                    <strong>Fewer Features: </strong>Restricted access to advanced features and analytics.
                                </CCol>
                            </CRow>
                        </p>
                    </CCol>
    
                    <CCol sm="6">
                        <CCard class="bg-white b-20 p-20" style="border:none">
                            <img src="../assets/img/Illustration2.png" style="max-width:100%" class="m-4 b-20" />
    
                        </CCard>
                    </CCol>
                </CRow>
            </CCol>
    
    
    
        </CCol>

        <CCol sm="12" class="bg-F5F5F5">
            <br /> <br /> <br />
            <CCol sm="12" lg="12">
                <div class="text-center p-2">
                    <CCol sm="12" style="width: 90%;margin: auto;">
                        <div class="text-center">
                            <br /><br /><br />
    
                            <h1 class="custom-40px-600" data-aos="fade-left">
                                AI-Conducted Interviews Benefited these <br />
job seekers and more than <span class="font-color-615FCD">33,000</span> others
                            </h1>
                            <p class="custom-16px-400 text-center ml-4" data-aos="fade-right">You’re a mock interview away from your dream job.</p>
                            <CRow class="p-0">
                                <CCol sm="4">
                                   <CCard class="border-12px m-2" style="border:none">
                                   <h4 class="custom-18px-400 p-20 text-left">
                                    "AI interview technology was a game-changer for me. As a recent graduate, I struggled to get noticed by employers."
                                   </h4>
                                   <CCol sm="12" class="p-0">
                                    <hr /> 
                                   </CCol>
                                   <CCol sm="12">
                                   <CRow>
                                    <CCol sm="4">
                                        <img style="max-width:100%" src="../assets/img/A1.png" />
                                    </CCol>
                                    <CCol sm="8" class="text-left">
                                        <label class="custom-16px-500">John D</label>
                                        <br />
                                        <img style="max-width:30px" src="../assets/img/star-yellow.png" />
                                        <img style="max-width:30px" src="../assets/img/star-yellow.png" />
                                        <img style="max-width:30px" src="../assets/img/star-yellow.png" />
                                        <img style="max-width:30px" src="../assets/img/star-yellow.png" />
                                        <img style="max-width:30px" src="../assets/img/star-yellow.png" />
                                    </CCol>
                                   </CRow>
                                </CCol>

                                   </CCard>
                                </CCol>
                                <CCol sm="4">
                                    <CCard class="border-12px m-2" style="border:none">
                                   <h4 class="custom-18px-400 p-20 text-left">
                                    "The AI interview process was incredibly thorough and fair. It evaluated my responses, body language, and even my..."
                                   </h4>
                                   <CCol sm="12" class="p-0">
                                    <hr /> 
                                   </CCol>
                                   <CCol sm="12">
                                   <CRow>
                                    <CCol sm="4">
                                        <img style="max-width:100%" src="../assets/img/A2.png" />
                                    </CCol>
                                    <CCol sm="8" class="text-left">
                                        <label class="custom-16px-500">Emma W</label>
                                        <br />
                                        <img style="max-width:30px" src="../assets/img/star-yellow.png" />
                                        <img style="max-width:30px" src="../assets/img/star-yellow.png" />
                                        <img style="max-width:30px" src="../assets/img/star-yellow.png" />
                                        <img style="max-width:30px" src="../assets/img/star-yellow.png" />
                                    </CCol>
                                   </CRow>
                                   </CCol>
                                   
                                   </CCard>
                                </CCol>
                                <CCol sm="4">
                                    <CCard class="border-12px m-2" style="border:none">
                                   <h4 class="custom-18px-400 p-20 text-left">
                                    "It has significantly improved our ability to identify the right candidates by providing consistent, unbiased assessments”
                                   </h4>
                                   <CCol sm="12" class="p-0">
                                    <hr /> 
                                   </CCol>
                                   <CCol sm="12">
                                   <CRow>
                                    <CCol sm="4">
                                        <img style="max-width:100%" src="../assets/img/A3.png" />
                                    </CCol>
                                    <CCol sm="8" class="text-left">
                                        <label class="custom-16px-500">Jason T</label>
                                        <br />
                                        <img style="max-width:30px" src="../assets/img/star-yellow.png" />
                                        <img style="max-width:30px" src="../assets/img/star-yellow.png" />
                                        <img style="max-width:30px" src="../assets/img/star-yellow.png" />
                                        <img style="max-width:30px" src="../assets/img/star-yellow.png" />
                                    </CCol>
                                   </CRow>
                                   </CCol>
                                   
                                   </CCard>
                                   
                                </CCol>


                                <CCol sm="4">
                                   <CCard class="border-12px m-2" style="border:none">
                                   <h4 class="custom-18px-400 p-20 text-left">
                                    "It has greatly improved our ability to find the right candidates quickly and accurately. The AI provides consistent.."
                                   </h4>
                                   <CCol sm="12" class="p-0">
                                    <hr /> 
                                   </CCol>
                                   <CCol sm="12">
                                   <CRow>
                                    <CCol sm="4">
                                        <img style="max-width:100%" src="../assets/img/A4.png" />
                                    </CCol>
                                    <CCol sm="8" class="text-left">
                                        <label class="custom-16px-500">Maria S.</label>
                                        <br />
                                        <img style="max-width:30px" src="../assets/img/star-yellow.png" />
                                        <img style="max-width:30px" src="../assets/img/star-yellow.png" />
                                        <img style="max-width:30px" src="../assets/img/star-yellow.png" />
                                        <img style="max-width:30px" src="../assets/img/star-yellow.png" />
                                    </CCol>
                                    </CRow>
                                </CCol>

                                   </CCard>
                                </CCol>
                                <CCol sm="4">
                                    <CCard class="border-12px m-2" style="border:none">
                                   <h4 class="custom-18px-400 p-20 text-left">
                                    "The AI provides consistent, unbiased evaluations, ensuring we find individuals who truly fit our requirements."
                                   </h4>
                                   <CCol sm="12" class="p-0">
                                    <hr /> 
                                   </CCol>
                                   <CCol sm="12">
                                   <CRow>
                                    <CCol sm="4">
                                        <img style="max-width:100%" src="../assets/img/A5.png" />
                                    </CCol>
                                    <CCol sm="8" class="text-left">
                                        <label class="custom-16px-500">Michael T</label>
                                        <br />
                                        <img style="max-width:30px" src="../assets/img/star-yellow.png" />
                                        <img style="max-width:30px" src="../assets/img/star-yellow.png" />
                                        <img style="max-width:30px" src="../assets/img/star-yellow.png" />
                                        <img style="max-width:30px" src="../assets/img/star-yellow.png" />
                                    </CCol>
                                    </CRow>
                                   </CCol>
                                   
                                   </CCard>
                                </CCol>
                                <CCol sm="4">
                                    <CCard class="border-12px m-2" style="border:none">
                                   <h4 class="custom-18px-400 p-20 text-left">
                                    "The AI interview was a unique and enlightening experience. It highlighted aspects of my performance that I hadn't.."
                                   </h4>
                                   <CCol sm="12" class="p-0">
                                    <hr /> 
                                   </CCol> 
                                   <CCol sm="12"> 
                                   <CRow>
                                    <CCol sm="4">
                                        <img style="max-width:100%" src="../assets/img/A6.png" />
                                    </CCol>
                                    <CCol sm="8" class="text-left">
                                        <label class="custom-16px-500">Sophia R</label>
                                        <br />
                                        <img style="max-width:30px" src="../assets/img/star-yellow.png" />
                                        <img style="max-width:30px" src="../assets/img/star-yellow.png" />
                                        <img style="max-width:30px" src="../assets/img/star-yellow.png" />
                                        <img style="max-width:30px" src="../assets/img/star-yellow.png" />
                                    </CCol>
                                   </CRow>
                                   </CCol>
                                   
                                   </CCard>
                                   
                                </CCol>
                               
                            </CRow>
                        </div>
                    </CCol>
    
                </div>
            </CCol>
        </CCol>

        <CCol sm="12" style="background-size: cover;color: #fff;" class="bg-F5F5F5 p-1">
            <br /> <br /> <br />
            <CCol sm="12" lg="12">
                <div class="text-center p-2">
                    <CCol sm="12" style="width: 80%;margin: auto;" class="d-sm-down-none">
                        <div class="text-center" style="background-size: cover;border-radius: 20px;" :style="{ backgroundImage: `url(${backgroundUrNoArrow})` }">
                            <br />
                            <br /> <br /> <br />
                            <h1 class="custom-header-join text-white poppin-font text-48px mt-5">Subscribe Now for Free</h1>
                            <br />
                            <label class="custom-header-join-sub text-white">
                                                        Sign up now for free and take the first step toward landing your dream job!
                                                                                        </label>
                            <br />
                            <br /> <br /> <br />
                            <CButton class="button-Explore"><span class="ml-2 mr-2">Inquire</span></CButton>
                            <br />
                            <br /> <br /> <br />
                            <br />
                        </div>
                    </CCol>
    
                    <CCol sm="12" style="width: 100%;margin: auto;" class="d-md-none">
                        <div class="text-center" style="background-size: cover;border-radius: 20px;" :style="{ backgroundImage: `url(${backgroundUrNoArrow})` }">
                            <br />
                            <br /> <br /> <br />
                            <h1 class="custom-header-join text-white poppin-font text-48px mt-5">Subscribe Now for Free</h1>
                            <br />
                            <label class="custom-header-join-sub text-white">
                                                        Sign up now for free and take the <br /> first step toward landing your dream job!
                                                                                        </label>
                            <br />
                            <br /> <br /> <br />
                            <CButton class="button-Explore"><span class="ml-2 mr-2">Inquire</span></CButton>
                            <br />
                            <br /> <br /> <br />
                            <br />
                        </div>
                    </CCol>
                </div>
                <br /><br /><br />
            </CCol>
    
    
        </CCol>
    
        <div v-if="isPopupVisibleSuccess" class="popup-all backdrop-all">
            <div class="popup-all1">
                <!-- Popup content -->
                <div class="text-center">
                    <img style="max-width:100px" src="../assets/img/success.png" />
                    <h3 class="custom-32px-500">Success!</h3>
                    <h3 class="custom-18px text-center">Succesfully save the form</h3>
                </div>
                <CButton class="button-border-202020" @click="closePopup" block><span class="ml-2 mr-2">Close</span></CButton>
            </div>
        </div>
        <div v-if="isPopupForm" class="popup-all backdrop-all">
            <div class="popup-all1">
                <div class="text-right">
                <img src="../assets/img/close.png" style="max-width:50px;" @click="closePopup1" />
            </div>
                <!-- Popup content -->
                <div class="text-left">
                    <h4>Subscribe to Our Enterprise Package</h4>
<label>Thank you for your interest in our Enterprise Package. Please fill out the form below, and one of our administrators will contact you soon to discuss the details and complete your subscription.</label>
                    <h5 class="custom-14px-500 font-general-sans">Name</h5>
                    <CInput type="text" v-model="Name"/>
                    <h5 class="custom-14px-500 font-general-sans">Company</h5>
                    <CInput type="text" v-model="Company"/>
                    <h5 class="custom-14px-500 font-general-sans">Contact No</h5>
                    <CInput type="text" v-model="ContactNo"/>
                    <h5 class="custom-14px-500 font-general-sans">Email</h5>
                    <CInput type="text" v-model="Email"/>
                    <CAlert color="danger" v-if="ErrorEmail ===true">Error! Please use a company email address</CAlert>
                    <h5 class="custom-14px-500 font-general-sans">Message</h5>
                    <CTextarea type="text" v-model="Message"/>
                </div>
                <CButton class="button-border-202020" @click="submitForm" block><span class="ml-2 mr-2">Send</span></CButton>
            </div>
        </div>
        <Footerlayout></Footerlayout>
    
    </div>
</template>


<script>
import Vue from "vue";


import { Carousel3d, Slide } from "vue-carousel-3d";
import MarqueeText from "vue-marquee-text-component";

Vue.component("marquee-text", MarqueeText);
import AOS from "aos";
import "aos/dist/aos.css";

Vue.use(Carousel3d);

import backgroundUrl from "../assets/img/bgPurpleYellow.png";
import backgroundUrl1 from "../assets/img/BgPeople.png";
import backgroundGenie from "../assets/img/bggenie.png";
import backgroundUrNoArrow from "../assets/img/bgline.png";

import Mainlayout from "../containers/AllHeader.vue";
import MainlayoutLogin from "../containers/LoginHeader.vue";
import Footerlayout from "../containers/TheFooter.vue";
import ToggleCard from '../components/Toggle.vue';


export default {
    name: "Login",
    components: {
        Carousel3d,
        Slide,
        MarqueeText,
        Mainlayout,
        MainlayoutLogin,
        Footerlayout,
        ToggleCard,
    },

    data() {
        return {
            backgroundUrl,
            backgroundUrl1,
            backgroundUrNoArrow,

            backgroundGenie,
            isActive: false,


            packages: [],
            isPopupForm: false,

            Name: "",
            Email: "",
            Company: "",
            ContactNo: "",
            Message: "",

      publicEmailProviders: ['gmail.com', 'hotmail.com', 'yahoo.com', 'outlook.com'],
      ErrorEmail: false,
      isPopupVisibleSuccess: false
   



        };
    },
    filters: {
    formattedPrice(value) {
      if (typeof value === "number") {
        return value % 1 === 0 ? value.toString() : value.toFixed(2);
      }
      return value;
    }
  },
    created() {
        AOS.init();
    },
    mounted() {
        this.GetListPackage();
    },
    methods: {
        formatDescription(description) {
      const index = description.indexOf(':');
      if (index !== -1) {
        const boldPart = description.substring(0, index + 1);
        const restPart = description.substring(index + 1);
        return `<strong>${boldPart}</strong>${restPart}`;
      }
      return description;
    },
        GoToConfirmation(amount, packageId) {
            this.$router.push("ConfirmationPackage?amount=" + amount + "&packageId=" + packageId);
        },
        async GetListPackage() {
            try {
                const response = await this.$API.get(this.$GetListPackageCompany);
                if (response.status === 200 && response.data) {
                    this.packages = response.data;
                }
            } catch (error) {
                console.error("Error fetching user info:", error);
            }
        },
        OpenForm()
        {
            this.isPopupForm = true;
        },
    
        isCompanyEmail(email) {
      const domain = email.split('@')[1];
      return !this.publicEmailProviders.includes(domain);
    },
        submitForm()
        {
            if (!this.isCompanyEmail(this.Email)) {
                this.ErrorEmail = true;
        return;
      }
            const formData = new FormData();
            formData.append("name", this.Name);
            formData.append("company", this.Company);
            formData.append("contactno", this.ContactNo);
            formData.append("email", this.Email);
            formData.append("message", this.Message);
            

            this.$API
                .post(this.$EnterpriseContact, formData)
                .then((response) => {
                    if (response.data.status === 400) {
                        this.Loading = false;
                        this.Message = response.data.message;
                        this.Error = true;
                    }
                    if (response.status == 200) {
                        if (response.data.status !== 400) {
                            this.isPopupForm = false;
                           this.isPopupVisibleSuccess = true;
                           
                        } else {
                            this.Loading = false;
                            this.Message = response.data.message;
                            this.Error = true;
                        }
                    } else {
                        this.Loading = false;
                        this.Error = true;
                        this.Message = response.data.message;
                    }
                })
                .catch((error) => {
                    this.Loading = false;
                    this.Error = true;
                    this.Message = error.response.data.message;
                });
        },
        closePopup1()
    {
        this.isPopupForm = false;
    },
    closePopup()
    {
        this.isPopupVisibleSuccess = false;
    },




    },

};
</script>

<style scoped>
@import url('https://fonts.cdnfonts.com/css/general-sans');
body {
    top: 0 !important;
    font-family: 'General Sans', sans-serif;
}
</style>